
    import "src/app/AppSeller/SettingsPage/Invoicing/InvoicingForm/index.module.scss?farm_css_modules";
    
    export default {"addressContainer": `addressContainer-28c7764a`,"box": `box-28c7764a`,"form": `form-28c7764a`,"gridContainer": `gridContainer-28c7764a`,"input": `input-28c7764a`,"invoicingForm": `invoicingForm-28c7764a`,"uploadContainer": `uploadContainer-28c7764a`,"warehouseName": `warehouseName-28c7764a`}
    